import React, { Component } from 'react';
import PropTypes from 'prop-types';

class LoadingSpinner extends Component {

  static propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
  }

  static defaultProps = {
    className: '',
    style: {},
  }

  render() {
    const {
      className,
      style,
    } = this.props;

    return (
      <div className={`LoadingSpinner ${className}`} style={style}>
        <i
          className="ion-load-c LoadingSpinner_icon--spin"
          aria-hidden="true"
        ></i>
      </div>
    );
  }
}

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner/LoadingSpinner.js